import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { OvertimeApprovalDetailPage } from "@/components/supervisor/overtime/OvertimeApprovalDetailPage";
import { requireSetting, requirePermission } from "@/lib/feature-gate";

export const Route = createFileRoute("/admin/_layout/overtime/monitoring_/$id")({
  beforeLoad: async () => {
    requireSetting("overtime_approval_required");
    await requirePermission("attendance.overtime.view");
  },
  component: AdminOvertimeMonitoringDetail,
});

function AdminOvertimeMonitoringDetail() {
  const { id } = useParams({
    from: "/admin/_layout/overtime/monitoring_/$id",
  });
  return (
    <SidebarInset>
      <DashboardHeader current={"Overtime Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <OvertimeApprovalDetailPage approvalId={id} />
      </div>
    </SidebarInset>
  );
}
